import { createReportFreeVariation } from '../../../../shared/mixpanel/events/createReportFreeVariation';

export const reportFreeVariation = createReportFreeVariation('Saved Logos');

export { reportFavoritesSellerClick } from './reportFavoritesSellerClick';
export { reportLogoSellerClicked } from './reportLogoSellerClicked';
export { reportMakeNewLogo } from './reportMakeNewLogo';
export { reportMyDraftsBuyDownload } from './reportMyDraftsBuyDownload';
export { reportMyDraftsDelete } from './reportMyDraftsDelete';
export { reportMyDraftsDuplicate } from './reportMyDraftsDuplicate';
export { reportMyDraftsEdit } from './reportMyDraftsEdit';
export { reportMyFavoritesLogoClicked } from './reportMyFavoritesLogoClicked';
export { reportMyOrderCreateNewVariation } from './reportMyOrderCreateNewVariation';
export { reportMyOrdersDownloadFiles } from './reportMyOrdersDownloadFiles';
export { reportNonActiveSellerProjects } from './reportNonActiveSellerProjects';
export { reportPageView } from './reportPageView';
export { reportRemovedFromFavorites } from './reportRemovedFromFavorites';
export { reportRemoveFromFavorites } from './reportRemoveFromFavorites';
export { reportViewMyDesigns } from './reportViewMyDesigns';
export { reportViewMyFavorites } from './reportViewMyFavorites';
